import React, { Fragment } from "react"
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import PropTypes from 'prop-types';

function IconInputText({ iconName, placeholderName, name, type, value, required, onChange, iconStyle, iconPosition, ...rest }) {
    return (<Fragment>
        <IconField iconPosition={iconPosition}>
            <InputIcon style={iconStyle} className={`pi ${iconName}`}> </InputIcon>
            <InputText onChange={onChange} value={value}  icon={`pi ${iconName}`} placeholder={`${placeholderName}`} {...rest} />
        </IconField>
    </Fragment>)
}
IconInputText.propTypes = {
    iconName: PropTypes.string, // Add this line
    placeholder:PropTypes.string,
    name:PropTypes.string,
    type:PropTypes.string,
    value:PropTypes.object,
    required:PropTypes.bool,
    onChange:PropTypes.func,
    iconStyle:PropTypes.object,
    iconPosition:PropTypes.string
};
export default IconInputText;